import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableSortLabelProps,
} from "@mui/material";
import React from "react";
import { TableInstanceProps } from "./ITable";
import type { ColumnInstance } from "react-table";

const CustomTableHead: React.FC<TableInstanceProps> = ({
  instance,
  mode,
  onTableChange,
  state,
}) => {
  const sortLabelProps = (column: ColumnInstance<any>): TableSortLabelProps => {
    if (mode === "local") {
      return {
        active: column.isSorted,
        direction: column.isSortedDesc ? "desc" : "asc",
        disabled: !column.canSort,
        onClick: () => onSortLabelClick(column),
      };
    } else {
      return {
        active: state.orderBy === column.id,
        direction: state.order,
        disabled: !column.canSort,
        onClick: () => onSortLabelClick(column),
      };
    }
  };

  const onSortLabelClick = (column: ColumnInstance<any>) => {
    if (mode === "local") {
      instance.toggleSortBy(
        column.id,
        column.isSorted ? !column.isSortedDesc : false
      );
    } else {
      onTableChange("sort", {
        sortField: column.id,
        sortOrder:
          state.orderBy === column.id
            ? state.order === "asc"
              ? "desc"
              : "asc"
            : "asc",
      });
    }
  };

  return (
    <TableHead>
      <TableRow>
        {instance.headers.map((column: ColumnInstance<any>, index) => (
          <TableCell
            {...column.getHeaderProps()}
            align={index === 0 ? "left" : "right"}
          >
            <TableSortLabel {...sortLabelProps(column)}>
              <b>{column.render("Header")}</b>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomTableHead;
